import { CancelOrderLineRouteService } from 'common/data';
import { findParams } from 'core/utils';
import { BaseService } from 'core/services';

class CancelOrderLineService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new CancelOrderLineRouteService());
	}

	cancelAmazonOrder(id, sourceOfChange) {
		var url = this.routeService.cancelAmazonOrder(id, sourceOfChange);
		return this.apiClient.get(url);
	}

	cancelMiraklOrder(id, sourceOfChange) {
		var url = this.routeService.cancelMiraklOrder(id, sourceOfChange);
		return this.apiClient.get(url);
	}

	refundAllOrderLines(id, sourceOfChange) {
		var url = this.routeService.refundAllOrderLines(id, sourceOfChange);
		return this.apiClient.get(url);
	}

	refundOrderLine(id, sourceOfChange) {
		var url = this.routeService.refundOrderLine(id, sourceOfChange);
		return this.apiClient.get(url);
	}
}

export default CancelOrderLineService;



// WEBPACK FOOTER //
// ./src/common/data/services/CancelOrderLineService.js